module.exports = __webpack_public_path__ + "static/media/Immobilier-Projet-Vaud-1.6587cf0f.jpg";